module.exports = __webpack_public_path__ + "static/media/404.46463a4f.png";